import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

@inject('cloudItemsStore')
@observer
class EntryCounter extends Component {
  render() {
    return (
      <span className={`${this.props.className} lg:text-gray-7`}>
        {this.props.cloudItemsStore.meta.total_entries} Results
      </span>
    )
  }
}

export default EntryCounter
